import React from 'react';
import { Outlet } from 'react-router-dom';

const Programs = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Programs